import React from 'react'

function ConfirmOrder() {
  return (
    <div>
      ConfirmOrder
    </div>
  )
}

export default ConfirmOrder
